import { urgentCareRoutes } from '@/lib/routes/urgentCare'

/** Session key for the UrgentCare::Order created at booking-confirm off-ramp. */
export const URGENT_CARE_ORDER_ID_SESSION_KEY = 'urgentCareOrderId'

/**
 * Hyphenated slug used for insurance-flow analytics when the catalog name is
 * not loaded yet. Matches typical SKU URL segments.
 */
export const URGENT_CARE_INSURANCE_SKU_NAME = 'urgent-care'

/** SSI entry used when the patient still needs insurance self-serve. */
export const URGENT_CARE_BOOKING_INSURANCE_PATH = '/insurance'

/**
 * After the patient confirms they want GM to book urgent care: persist the new
 * order id and point the insurance self-serve flow at the UC SKU + options
 * return path (single Solv offer auto-selects, then locations).
 */
export function prepareUrgentCareInsuranceHandoff(orderId: string, urgentCareSkuId: string): void {
    if (typeof window === 'undefined') return

    sessionStorage.setItem(URGENT_CARE_ORDER_ID_SESSION_KEY, orderId)
    sessionStorage.setItem('insuranceSkuId', urgentCareSkuId)
    sessionStorage.setItem('insuranceSkuName', URGENT_CARE_INSURANCE_SKU_NAME)
    sessionStorage.setItem('insuranceReturnUrl', urgentCareRoutes.options(orderId))
    sessionStorage.setItem('showContinueWithoutInsuranceButton', 'true')
    sessionStorage.removeItem('insuranceVisitId')
    sessionStorage.removeItem('ssiFirstStepTracked')
    // Drop a leftover in-person referral session so insurance redirects to UC locations.
    sessionStorage.removeItem('referralOrderId')
    document.cookie = 'referralOrderId=; path=/; max-age=0'
}

/**
 * Skip SSI when `GET /api/external/insurances/show` already returned a plan
 * (same outcome as the video-booking gate in SkuDetailPageRouter) and continue
 * at UC options.
 */
export function urgentCarePostConfirmPath(orderId: string, patientHasActiveInsurance: boolean): string {
    if (patientHasActiveInsurance) {
        return urgentCareRoutes.options(orderId)
    }
    return URGENT_CARE_BOOKING_INSURANCE_PATH
}

export function clearUrgentCareOrderSession(): void {
    if (typeof window === 'undefined') return
    sessionStorage.removeItem(URGENT_CARE_ORDER_ID_SESSION_KEY)
}

export function readUrgentCareOrderIdFromSession(): string | null {
    if (typeof window === 'undefined') return null
    return sessionStorage.getItem(URGENT_CARE_ORDER_ID_SESSION_KEY)?.trim() || null
}
